module.exports = "/images/nr.svg?d7e008f5b0c3cbc3687361865bf0b7aa";